module.exports = __webpack_public_path__ + "static/media/team_about_bottom_2025@2x.a5af8bb5.png";